// 검색 전역 공통: 영문 대소문자를 구분하지 않고 포함 여부를 판단 (서버 검색은 SQL ILIKE 로 이미 동일하게 동작)
export const includesCI = (text, query) =>
  String(text ?? '').toLowerCase().includes(String(query ?? '').toLowerCase());

// 검색어가 비었거나, 주어진 필드 중 하나라도 검색어를 포함하면 true
export const matchAnyCI = (query, ...fields) => !query || fields.some(f => includesCI(f, query));
